// extracted by mini-css-extract-plugin
export default {"NewsLetter":"NewsLetter_NewsLetter__b+e8d","Left":"NewsLetter_Left__ZvtF6","Right":"NewsLetter_Right__fOWt4"};